import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { TypeOfKey } from '../../model/type-of-key';
import {
  AutoCompleteSelectionState,
  IAutoCompleteService,
} from '../../../core/component/autocomplete-remote/autocomplete-service.interface';
import { Observable, map } from 'rxjs';
import { AutoCompleteSelectionItem } from '../../../core/component/autocomplete-remote/autocomplete-selection-item';

@Injectable()
export class KeyTypeService extends DataService<TypeOfKey> implements IAutoCompleteService<TypeOfKey> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, TypeOfKey, progressBar, 'keytype');
  }
  getSelectionItem(id: string, state: AutoCompleteSelectionState<TypeOfKey, any>): Observable<AutoCompleteSelectionItem<TypeOfKey>> {
    return this.get(id).pipe(map(r => new AutoCompleteSelectionItem(r.name, r.id, r)));
  }

  getSelection(filter: string, options: any, page?: number): Observable<AutoCompleteSelectionItem<TypeOfKey>[]> {
    return this.getList().pipe(
      map(c =>
        page > 1
          ? []
          : c
              .filter(r => !filter?.length || filter === '*' || r.name.toUpperCase().indexOf(filter.toUpperCase()) >= 0)
              .map(r => new AutoCompleteSelectionItem(r.name, r.id, r))
      )
    );
  }
}
